import './Modal.scss';

import { AlertModal } from '@festo-ui/react';
import React from 'react';

import useTranslation from '../../features/translation/hooks/useTranslation';

enum TranslationKeys {
  CANCEL_MODAL = 'cancelModal',
  CONTINUE_MODAL = 'continueModal',
  WARNING_MODAL_SUBTITLE = 'warningModalSubtitle',
  WARNING_MODAL_TITLE = 'warningModalTitle',
  WARNING_MODAL_BODY = 'warningModalBody',
}

export interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  onOk?: () => void;
  onCancel?: () => void;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onCancel, onClose, onOk }) => {
  const t = useTranslation();
  return (
    <AlertModal
      alertType="warning"
      className="ems-modal--to-overview"
      body={t(TranslationKeys.WARNING_MODAL_BODY)}
      title={t(TranslationKeys.WARNING_MODAL_TITLE)}
      subtitle={t(TranslationKeys.WARNING_MODAL_SUBTITLE)}
      isOpen={isOpen}
      ok={t(TranslationKeys.CONTINUE_MODAL)}
      cancel={t(TranslationKeys.CANCEL_MODAL)}
      onCancel={onCancel}
      onClose={onClose}
      onOk={onOk}
    />
  );
};

export default Modal;
